import { Button, Dialog, Typography } from '@pwskills/rachnaui';

type PaymentModalProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleRetry: () => void;
};

const PaymentFailureModal = (props: PaymentModalProps) => {
  const { open, setOpen, handleRetry } = props;
  return (
    <Dialog
      open={open}
      closeModal={() => setOpen(false)}
      closeEnable={false}
      className="z-[99999] large:!w-[42%] !p-[32px] regular:!px-[56px] regular:!py-8 large:!px-[140px] large:!py-14  regular:!w-[60%] rounded-xl"
    >
      <div className="flex flex-col gap-4  medium:gap-9 justify-center items-center">
        <img src="/images/checkout/error-mark.gif" alt="success" className="w-[200px] h-[200px]" />
        <Typography component="body-regular" variant="bold" className="text-center text-gray-900">
          Seems like there’s a trouble with your payment!
        </Typography>
        <Button
          onClick={() => {
            setOpen(false);
            handleRetry();
          }}
        >
          Try Again
        </Button>
      </div>
    </Dialog>
  );
};
export default PaymentFailureModal;
